import * as React from "react";
import { Modal, Button } from "react-bootstrap";
import { useAppSelector } from "../../hooks/redux-hooks";
import { AppState } from "../../../store";
import { SessionTimeoutHelper } from "@sssuite-component-ui/session-timeout";
import { signoutRedirect } from "../../../oidc-client/userService";
import { useAppDispatch } from "../../hooks/redux-hooks";
import { userSignedOut } from "../../../store/services/auth-service";
import AppRoute from "../../../route";
import "./LogoutModal.scss";

interface Props {
  onToggle(prop:boolean): void;
  show:boolean;
}

const LogoutModal: React.FC<Props> = (props: Props) => {
    const dispatch = useAppDispatch();

    const {device_id}: any = useAppSelector(
      (state: AppState) => state.authReducer?.authentication.user.profile
    );

    const onDiscardButtonClick = () => {
        props.onToggle(false);        
    };

    const onLogoutButtonClick = () => {
        SessionTimeoutHelper.logoutHelper(device_id, signoutRedirect);         
        dispatch(userSignedOut());        
    };    

    const onHide = () => {
      props.onToggle(false);
    };    
    return (
      <>
        <div>
          <Modal
            role="dialog"   
            show={props.show}            
            dialogClassName="common-modal"      
            keyboard={true}      
            onHide={onHide}
          >
            <Modal.Header className="common-modal-header">
              <span className="common-modal-header-text">Log Out</span>
            </Modal.Header>
            <Modal.Body className="common-modal-content">
              Are you sure you want to log out? You will be logged out of all
              instances of the SafeSend Suite.
            </Modal.Body>
            <Modal.Footer className="common-modal-footer">
              <button
                className="modal-secondary-button secondary-btn-bg"
                onClick={onDiscardButtonClick}
              >
                No, Discard
              </button>
              <button
                className="modal-primary-button red-btn-bg"
                onClick={onLogoutButtonClick}
              >
                Yes, Log Out
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
}

export default LogoutModal;